var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Link as LinkRR } from 'react-router-dom';
import styled from 'styled-components';
import { combinedCss } from './styles';
var StyledLink = styled.a(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n  text-decoration: none;\n"], ["\n  ", "\n  text-decoration: none;\n"])), function (p) { return combinedCss(p); });
var StyledLinkText = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", "\n  text-decoration: none;\n  width: 100%;\n  height: 100%;\n"], ["\n  ", "\n  text-decoration: none;\n  width: 100%;\n  height: 100%;\n"])), function (p) { return combinedCss(p); });
export var Link = function (_a) {
    var children = _a.children, to = _a.to, externalURL = _a.externalURL, props = __rest(_a, ["children", "to", "externalURL"]);
    if (!externalURL && !to) {
        throw Error('externalURL or to prop needed.');
    }
    if (externalURL) {
        return (_jsx(StyledLink, __assign({ href: externalURL, target: "_blank" }, props, { children: children }), void 0));
    }
    return (_jsx(LinkRR, __assign({ style: { textDecoration: 'none' }, to: { pathname: to } }, { children: _jsx(StyledLinkText, __assign({}, props, { children: children }), void 0) }), void 0));
};
var templateObject_1, templateObject_2;
//# sourceMappingURL=Link.js.map